<span [style.color]="color">{{ text }}</span><span *ngIf="detail" style="font-size: 14px; color: #555;"><br>{{ detail }}</span>